// Small, safe Markdown for agent replies: paragraphs, lists, **bold**, *italic*,
// `code` and links. Everything is escaped first, so the output is only the tags
// built here. Links keep to http(s), mailto, tel and same-site paths.
const ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }
const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => ESCAPES[char])

const SAFE_URL = /^(https?:\/\/|mailto:|tel:|\/(?!\/))/i

function link (label, url) {
  const href = url.replace(/&amp;/g, "&")
  if (!SAFE_URL.test(href)) return label

  const external = /^https?:\/\//i.test(href) && !href.startsWith(window.location.origin)
  const attrs = external ? ' target="_blank" rel="noopener noreferrer"' : ""
  return `<a href="${escapeHtml(href)}"${attrs} class="underline underline-offset-2 break-words">${label}</a>`
}

function inline (escaped) {
  const stash = []
  const keep = (html) => `\u0000${stash.push(html) - 1}\u0000`

  let out = escaped
    .replace(/`([^`]+)`/g, (_, code) => keep(`<code class="rounded bg-accent-softer px-1 py-0.5 text-[0.85em]">${code}</code>`))
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, label, url) => keep(link(label, url)))
    .replace(/(^|[\s(])(https?:\/\/[^\s<)]+[^\s<).,;:!?])/g, (_, lead, url) => `${lead}${keep(link(url, url))}`)
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*\s][^*]*)\*/g, "$1<em>$2</em>")

  return out.replace(/\u0000(\d+)\u0000/g, (_, index) => stash[Number(index)])
}

export function renderMarkdown (text) {
  const blocks = String(text || "").replace(/\r\n?/g, "\n").trim().split(/\n{2,}/)

  return blocks.map((block) => {
    const lines = block.split("\n")
    const bullet = lines.every((line) => /^\s*[-*•]\s+/.test(line))
    const numbered = lines.every((line) => /^\s*\d+[.)]\s+/.test(line))

    if (bullet || numbered) {
      const tag = bullet ? "ul" : "ol"
      const style = bullet ? "list-disc" : "list-decimal"
      const items = lines.map((line) => `<li>${inline(escapeHtml(line.replace(/^\s*(?:[-*•]|\d+[.)])\s+/, "")))}</li>`)
      return `<${tag} class="${style} space-y-1 pl-5">${items.join("")}</${tag}>`
    }

    return `<p>${lines.map((line) => inline(escapeHtml(line))).join("<br>")}</p>`
  }).join("")
}
